import React from 'react';

const TrashIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 20 20" fill="none" width={size} height={size} aria-hidden="true">
    <path
      d="M4 6h12M8 6V4h4v2M6 10v6M10 10v6M14 10v6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M5 6l1 11h8l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

export default TrashIcon;
